export interface BatchUserListRequest {
  userRegistrationDateFrom: string
  userRegistrationDateTo: string
  userRegistrationBranchCode: string
  userType: string
  order: string
  batchType: string
}

export function BatchUserListRequestToJSON(value: BatchUserListRequest): any {
  return {
    user_registration_date_from: value.userRegistrationDateFrom,
    user_registration_date_to: value.userRegistrationDateTo,
    user_registration_branch_code: value.userRegistrationBranchCode,
    user_type: value.userType,
    order: value.order,
    batch_type: value.batchType
  }
}
